// ==========================================================================
// GESTIÓN DEL CARRITO DE COMPRAS - APOLO 2027
// ==========================================================================

document.addEventListener('DOMContentLoaded', () => {
    // 1. SELECTORES GLOBALES DE LA INTERFAZ
    const cartOverlay = document.getElementById('cartOverlay');
    const drawerCart = document.getElementById('drawerCart');
    const cartCloseBtn = document.getElementById('cartCloseBtn');
    const cartItemsContainer = document.querySelector('.cart-items');
    const cartSubtotalElement = document.getElementById('cartSubtotal');
    const btnAddToCart = document.querySelector('.btn-add-to-cart');

    // 2. FUNCIONES DE PERSISTENCIA (LOCALSTORAGE)
    
    // Obtener el carrito desde LocalStorage
    const getCart = () => {
        try {
            const cartData = localStorage.getItem('apolo_cart');
            return cartData ? JSON.parse(cartData) : [];
        } catch (error) {
            console.warn("Datos del carrito corruptos. Reiniciando almacenamiento local.");
            localStorage.removeItem('apolo_cart');
            return [];
        }
    };

    // Guardar el carrito en LocalStorage
    const saveCart = (cart) => {
        try {
            localStorage.setItem('apolo_cart', JSON.stringify(cart));
        } catch (error) {
            console.error('Error al guardar el carrito en LocalStorage:', error);
        }
    };

    // 3. FUNCIONES DE CONTROL DE LA INTERFAZ (DRAWER)
    
    const openCart = () => {
        document.body.classList.add('cart-open');
        if (drawerCart) drawerCart.setAttribute('aria-hidden', 'false');
        cartCloseBtn?.focus();
    };

    const closeCart = () => {
        document.body.classList.remove('cart-open');
        if (drawerCart) drawerCart.setAttribute('aria-hidden', 'true');
    };

    // Registrar eventos para el drawer (Apertura y Cierre) y otros iconos de utilidad
    // Buscamos el botón de Carrito en el header
    const cartTrigger = document.getElementById('cart-trigger') || document.querySelector('.nav-actions button[aria-label="Carrito"]');
    if (cartTrigger) {
        cartTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            openCart();
        });
    }

    if (cartCloseBtn) {
        cartCloseBtn.addEventListener('click', closeCart);
    }

    if (cartOverlay) {
        cartOverlay.addEventListener('click', closeCart);
    }

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && document.body.classList.contains('cart-open')) {
            closeCart();
        }
    });

    // Lógica del Buscador Global (Lupa)
    const initSearchModal = () => {
        let overlay = document.getElementById('global-search-modal');
        if (!overlay) {
            overlay = document.createElement('div');
            overlay.id = 'global-search-modal';
            overlay.className = 'search-modal-overlay';
            overlay.innerHTML = `
                <div class="search-modal-container">
                    <div class="search-header">
                        <div class="search-input-wrapper">
                            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                            <input type="text" class="search-field" placeholder="¿Qué estás buscando? (Ej. Velox, Trail, etc.)" id="global-search-input" autocomplete="off">
                        </div>
                        <button class="search-close-btn" id="global-search-close" aria-label="Cerrar búsqueda">✕</button>
                    </div>
                    <div class="search-results" id="global-search-results">
                        <!-- Se llena dinámicamente -->
                    </div>
                </div>
            `;
            document.body.appendChild(overlay);
        }

        const searchInput = document.getElementById('global-search-input');
        const resultsContainer = document.getElementById('global-search-results');
        const closeBtn = document.getElementById('global-search-close');

        const searchProducts = [
            { id: "apolo-velox", name: "APOLO Velox", subCategory: "Running / Carretera", price: "$110.00", image: "assets/inventario/product-3.png" },
            { id: "apolo-helios", name: "APOLO Helios", subCategory: "Running / Trail", price: "$195.00", image: "assets/inventario/product-2.png" },
            { id: "apolo-aether", name: "APOLO Aether", subCategory: "Running / Performance", price: "$170.00", image: "assets/inventario/IDEA-01---White-Red.png" },
            { id: "apolo-aero", name: "APOLO Aero", subCategory: "Running / Diario", price: "$125.00", image: "assets/inventario/product-4.png" },
            { id: "apolo-confort-boots", name: "APOLO Confort Boots", subCategory: "Urban / Botas", price: "$145.00", image: "assets/inventario/product-5.png" },
            { id: "apolo-soccer-cleat", name: "APOLO Soccer Pro", subCategory: "Fútbol / Césped", price: "$160.00", image: "assets/inventario/soccer-activity.png" },
            { id: "apolo-sandals", name: "APOLO Sandals", subCategory: "Sandalias / Outdoor", price: "$85.00", image: "assets/inventario/product-6.png" }
        ];

        const renderSuggestions = () => {
            resultsContainer.innerHTML = `
                <div class="search-suggestions">
                    <h3 class="search-suggestions-title">Búsquedas Sugeridas</h3>
                    <div class="search-suggestions-chips">
                        <button class="search-suggestion-chip" data-query="Velox">Velox</button>
                        <button class="search-suggestion-chip" data-query="Trail">Trail</button>
                        <button class="search-suggestion-chip" data-query="Helios">Helios</button>
                        <button class="search-suggestion-chip" data-query="Boots">Botas</button>
                        <button class="search-suggestion-chip" data-query="Running">Running</button>
                    </div>
                </div>
            `;

            // Vincular eventos a los chips
            const chips = resultsContainer.querySelectorAll('.search-suggestion-chip');
            chips.forEach(chip => {
                chip.addEventListener('click', () => {
                    const query = chip.getAttribute('data-query');
                    searchInput.value = query;
                    performSearch(query);
                    searchInput.focus();
                });
            });
        };

        const performSearch = (query) => {
            const cleanQuery = query.toLowerCase().trim();
            if (!cleanQuery) {
                renderSuggestions();
                return;
            }

            const filtered = searchProducts.filter(p => 
                p.name.toLowerCase().includes(cleanQuery) || 
                p.subCategory.toLowerCase().includes(cleanQuery)
            );

            if (filtered.length === 0) {
                resultsContainer.innerHTML = `
                    <div class="search-no-results">
                        No se encontraron resultados para "${sanitizeInput(query)}". Intenta con otra palabra clave.
                    </div>
                `;
                return;
            }

            resultsContainer.innerHTML = `
                <div class="search-results-list">
                    ${filtered.map(p => `
                        <a href="pdp.html?product=${p.id}" class="search-result-item">
                            <img src="${p.image}" alt="${p.name}" class="search-result-img">
                            <div class="search-result-info">
                                <div class="search-result-name">${p.name}</div>
                                <div class="search-result-cat">${p.subCategory}</div>
                            </div>
                            <div class="search-result-price">${p.price}</div>
                        </a>
                    `).join('')}
                </div>
            `;
        };

        const openSearch = () => {
            overlay.classList.add('active');
            renderSuggestions();
            searchInput.value = '';
            setTimeout(() => searchInput.focus(), 100);
        };

        const closeSearch = () => {
            overlay.classList.remove('active');
        };

        // Escuchadores de apertura
        const searchTrigger = document.getElementById('search-trigger');
        if (searchTrigger) {
            searchTrigger.addEventListener('click', (e) => {
                e.preventDefault();
                openSearch();
            });
        }

        // Escuchadores de cierre
        closeBtn.addEventListener('click', closeSearch);
        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) {
                closeSearch();
            }
        });

        // Escuchador de escritura
        searchInput.addEventListener('input', (e) => {
            performSearch(e.target.value);
        });

        // Cerrar con Escape
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && overlay.classList.contains('active')) {
                closeSearch();
            }
        });
    };

    initSearchModal();

    // Lógica del Cambio de Tema (Sol / Luna)
    const themeToggleBtn = document.getElementById('theme-toggle') || document.getElementById('themeToggleBtn');
    const sunIcon = document.querySelector('.theme-icon-sun');
    const moonIcon = document.querySelector('.theme-icon-moon');

    const updateThemeUI = (theme) => {
        if (theme === 'dark') {
            document.documentElement.setAttribute('data-theme', 'dark');
            document.body.classList.add('dark-mode');
            if (sunIcon) sunIcon.style.display = 'none';
            if (moonIcon) moonIcon.style.display = 'block';
        } else {
            document.documentElement.setAttribute('data-theme', 'light');
            document.body.classList.remove('dark-mode');
            if (sunIcon) sunIcon.style.display = 'block';
            if (moonIcon) moonIcon.style.display = 'none';
        }
    };

    // Cargar preferencia guardada o por defecto light
    let savedTheme = 'light';
    try {
        savedTheme = localStorage.getItem('theme') || 'light';
    } catch (error) {
        console.warn("Error al leer 'theme' de localStorage. Usando tema por defecto.", error);
    }
    updateThemeUI(savedTheme);

    if (themeToggleBtn) {
        themeToggleBtn.addEventListener('click', () => {
            const currentTheme = document.documentElement.getAttribute('data-theme') || (document.body.classList.contains('dark-mode') ? 'dark' : 'light');
            const nextTheme = currentTheme === 'dark' ? 'light' : 'dark';
            localStorage.setItem('theme', nextTheme);
            updateThemeUI(nextTheme);
        });
    }

    // Lógica del Header interactivo con Scroll
    const header = document.querySelector('.site-header');
    const handleScroll = () => {
        if (header) {
            // No quitar la clase 'scrolled' en las páginas secundarias como catalog.html y pdp.html
            const isIndex = window.location.pathname.endsWith('index.html') || window.location.pathname === '/' || window.location.pathname.endsWith('');
            if (window.scrollY > 50) {
                header.classList.add('scrolled');
            } else if (isIndex) {
                header.classList.remove('scrolled');
            }
        }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    // Lógica de imágenes dinámicas del Mega Menú al pasar el puntero
    const megaLinks = document.querySelectorAll('.mega-menu-item-link');
    const featuredImg = document.getElementById('menuFeaturedImg');
    
    const imagesMap = {
        todo: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=600&q=80",
        zapatillas: "https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?auto=format&fit=crop&w=600&q=80",
        ropa: "https://images.unsplash.com/photo-1486218119243-13883505764c?auto=format&fit=crop&w=600&q=80",
        accesorios: "https://images.unsplash.com/photo-1541534741688-6078c6bfb5c5?auto=format&fit=crop&w=600&q=80"
    };

    if (megaLinks.length > 0 && featuredImg) {
        megaLinks.forEach(link => {
            link.addEventListener('mouseenter', (e) => {
                megaLinks.forEach(l => l.classList.remove('active'));
                e.target.classList.add('active');

                const cat = e.target.getAttribute('data-category');
                const nextSrc = imagesMap[cat] || imagesMap['todo'];
                
                if (featuredImg.src !== nextSrc) {
                    featuredImg.classList.add('fade-out');
                    setTimeout(() => {
                        featuredImg.src = nextSrc;
                        featuredImg.classList.remove('fade-out');
                    }, 150);
                }
            });
        });
    }

    // 4. FUNCIONES DE CÁLCULO Y RENDERIZADO

    // Actualizar el subtotal y la cantidad total de artículos
    const updateSubtotal = (cart) => {
        if (!cartSubtotalElement) return;
        
        const total = cart.reduce((sum, item) => {
            const price = parseFloat(item.price.replace('$', ''));
            return sum + (price * item.quantity);
        }, 0);

        cartSubtotalElement.textContent = `$${total.toFixed(2)}`;
    };

    // Renderizar la lista de productos en el carrito lateral
    const renderCart = () => {
        if (!cartItemsContainer) return;
        
        const cart = getCart();
        cartItemsContainer.innerHTML = '';

        if (cart.length === 0) {
            cartItemsContainer.innerHTML = `
                <div class="cart-empty-message" style="text-align: center; padding: 40px 20px; color: var(--theme-gray-text);">
                    <p>Tu carrito está vacío.</p>
                </div>
            `;
            updateSubtotal(cart);
            return;
        }

        cart.forEach(item => {
            const cartItemHTML = `
                <div class="cart-item" data-id="${item.id}" data-size="${item.size}">
                    <div class="cart-item-image">
                        <img src="${item.image}" alt="${item.title}">
                    </div>
                    <div class="cart-item-details">
                        <h3 class="cart-item-name">${item.title}</h3>
                        <p class="cart-item-meta">Talla: ${item.size}</p>
                        <p class="cart-item-price">${item.price}</p>
                    </div>
                    <div class="cart-item-quantity-wrapper" style="display: flex; flex-direction: column; align-items: flex-end; gap: 8px;">
                        <button class="cart-item-remove-btn" aria-label="Eliminar artículo" style="background: none; border: none; cursor: pointer; color: var(--theme-gray-text); font-size: 0.8rem; text-decoration: underline;">
                            Eliminar
                        </button>
                        <div class="cart-item-quantity">
                            <button class="qty-btn" aria-label="Disminuir cantidad" data-action="decrease">—</button>
                            <span class="qty-number">${item.quantity}</span>
                            <button class="qty-btn" aria-label="Aumentar cantidad" data-action="increase">+</button>
                        </div>
                    </div>
                </div>
            `;
            cartItemsContainer.insertAdjacentHTML('beforeend', cartItemHTML);
        });

        updateSubtotal(cart);
    };

    // 5. LÓGICA DE MUTACIONES DEL CARRITO

    // Añadir producto al carrito
    const addToCart = (product) => {
        const cart = getCart();
        
        // Comprobar si existe el mismo producto con la misma talla
        const existingItemIndex = cart.findIndex(item => item.id === product.id && item.size === product.size);

        if (existingItemIndex > -1) {
            cart[existingItemIndex].quantity += 1;
        } else {
            cart.push(product);
        }

        saveCart(cart);
        renderCart();
        openCart();
    };

    // Cambiar cantidad o eliminar ítems mediante delegation en el contenedor
    if (cartItemsContainer) {
        cartItemsContainer.addEventListener('click', (e) => {
            const cartItemNode = e.target.closest('.cart-item');
            if (!cartItemNode) return;

            const itemId = cartItemNode.dataset.id;
            const itemSize = cartItemNode.dataset.size;
            let cart = getCart();

            // Lógica para el botón "Eliminar"
            if (e.target.classList.contains('cart-item-remove-btn')) {
                cart = cart.filter(item => !(item.id === itemId && item.size === itemSize));
                saveCart(cart);
                renderCart();
                return;
            }

            // Lógica para botones de cantidad (+ / -)
            const qtyBtn = e.target.closest('.qty-btn');
            if (qtyBtn) {
                const action = qtyBtn.dataset.action;
                const itemIndex = cart.findIndex(item => item.id === itemId && item.size === itemSize);

                if (itemIndex > -1) {
                    if (action === 'increase') {
                        cart[itemIndex].quantity += 1;
                    } else if (action === 'decrease') {
                        cart[itemIndex].quantity -= 1;
                        // Si la cantidad llega a 0, se elimina del carrito
                        if (cart[itemIndex].quantity <= 0) {
                            cart.splice(itemIndex, 1);
                        }
                    }
                    saveCart(cart);
                    renderCart();
                }
            }
        });
    }

    // 6. EVENT LISTENERS Y CAPTURA EN LA PÁGINA DE DETALLE DE PRODUCTO (PDP)
    if (btnAddToCart) {
        btnAddToCart.addEventListener('click', (e) => {
            e.preventDefault();

            // Obtener talla seleccionada
            const selectedSizeBtn = document.querySelector('.size-btn.active');
            if (!selectedSizeBtn) {
                alert('Por favor, selecciona una talla antes de añadir a la cesta.');
                return;
            }
            
            // Extraer la talla (ejemplo: "US W 7 | COL 38" -> extrae "US W 7 | COL 38")
            const size = selectedSizeBtn.textContent.trim();

            // Extraer información básica de la variante activa en la PDP
            const activeColorBtn = document.querySelector('.color-btn.active');
            
            const title = document.getElementById('pdpTitle')?.textContent.trim() || 'APOLO Calzado';
            const price = document.getElementById('pdpPrice')?.textContent.trim() || '$170.00';
            const image = document.getElementById('pdpMainImg')?.getAttribute('src') || 'assets/inventario/IDEA-01---White-Red.png';
            
            // Generar un ID único ficticio combinando el título y la variante de color
            const colorId = activeColorBtn ? activeColorBtn.getAttribute('data-color') : 'default';
            const productId = `${title.toLowerCase().replace(/\s+/g, '-')}-${colorId}`;

            // Crear objeto del producto
            const product = {
                id: productId,
                title: title,
                price: price,
                image: image,
                size: size,
                quantity: 1
            };

            addToCart(product);
        });
    }

    // 7. INICIALIZAR EL CARRITO AL CARGAR LA PÁGINA
    renderCart();

    // 8. SANITIZACIÓN DE ENTRADAS CONTRA ATAQUES XSS
    const sanitizeInput = (inputString) => {
        if (typeof inputString !== 'string') return '';
        return inputString
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#x27;')
            .replace(/\//g, '&#x2F;');
    };

    // 9. VALIDACIÓN E INTERCEPCIÓN SEGURA DE FORMULARIOS
    const newsletterForms = document.querySelectorAll('.newsletter-form');
    newsletterForms.forEach(form => {
        const input = form.querySelector('.newsletter-input');
        const errorMessage = form.querySelector('.error-message');

        if (!input || !errorMessage) return;

        form.addEventListener('submit', (e) => {
            e.preventDefault();

            const rawValue = input.value;
            const sanitizedValue = sanitizeInput(rawValue.trim());
            const emailPattern = new RegExp(input.getAttribute('pattern') || '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$');

            if (!sanitizedValue) {
                input.classList.add('input-error');
                input.classList.remove('input-success');
                errorMessage.textContent = 'Este campo es obligatorio.';
            } else if (!emailPattern.test(sanitizedValue) || sanitizedValue.length > 50) {
                input.classList.add('input-error');
                input.classList.remove('input-success');
                errorMessage.textContent = 'Introduce un email válido (máx. 50 caracteres).';
            } else {
                input.classList.remove('input-error');
                input.classList.add('input-success');
                errorMessage.textContent = '';

                // Simulación de envío exitoso seguro
                console.log('Envío de datos sanitizados y validados:', sanitizedValue);
            }
        });

        // Limpiar errores visuales al escribir
        input.addEventListener('input', () => {
            input.classList.remove('input-error');
            input.classList.remove('input-success');
            errorMessage.textContent = '';
        });
    });

    // 10. REVELAR ELEMENTOS AL HACER SCROLL (INTERSECTION OBSERVER)
    const revealElements = document.querySelectorAll('.reveal-on-scroll');
    const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-revealed');
                // Detener la observación una vez animado
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.15,
        rootMargin: '0px 0px -20px 0px'
    });

    revealElements.forEach(element => {
        revealObserver.observe(element);
    });

    // Manejo de Formulario B2B Mayoristas
    const b2bForm = document.getElementById('b2b-form');
    const b2bContainer = document.getElementById('b2bFormContainer');

    if (b2bForm && b2bContainer) {
        b2bForm.addEventListener('submit', (e) => {
            e.preventDefault();

            const company = document.getElementById('b2b-company');
            const taxId = document.getElementById('b2b-tax-id');
            const contact = document.getElementById('b2b-contact');
            const phone = document.getElementById('b2b-phone');
            const email = document.getElementById('b2b-email');

            if (!company.value || !taxId.value || !contact.value || !phone.value || !email.value) {
                alert('Por favor, completa todos los campos del formulario.');
                return;
            }

            // Sanitización de datos
            const sanitizedCompany = sanitizeInput(company.value);
            const sanitizedContact = sanitizeInput(contact.value);

      // Inyectar éxito
      b2bContainer.innerHTML = `
        <div class="b2b-success-message">
          <h2 class="b2b-success-title">Solicitud Recibida</h2>
          <p class="b2b-success-desc">Gracias <strong>${sanitizedContact}</strong> por tu interés en APOLO. Hemos registrado los datos de <strong>${sanitizedCompany}</strong>. Un asesor de nuestro equipo comercial de distribución B2B se contactará contigo en las próximas 48 horas laborales.</p>
        </div>
      `;
    });
  }

  // --- MOTOR AJAX PARA CARRITO ---
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const formData = new FormData(productForm);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Error al añadir producto');
        }
        return response.json();
      })
      .then(() => {
        updateAndOpenCart();
      })
      .catch(error => {
        console.error('Error AJAX:', error);
      });
    });
  }

  function updateAndOpenCart() {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      renderCartDrawer(cart);
      openCart();
    })
    .catch(error => {
      console.error('Error al actualizar carrito:', error);
    });
  }

  function renderCartDrawer(cart) {
    const container = document.getElementById('cart-items-container') || document.querySelector('.cart-items');
    const subtotalElement = document.getElementById('cartSubtotal');
    if (!container) return;
    container.innerHTML = '';

    if (cart.items.length === 0) {
      container.innerHTML = '<p class="empty-cart-msg" style="text-align: center; padding: 40px; color: var(--theme-gray-text);">Tu bolsa está vacía.</p>';
      if (subtotalElement) subtotalElement.textContent = '$0.00';
      return;
    }

    cart.items.forEach(item => {
      const itemHTML = `
        <div class="cart-item" data-key="${item.key}">
          <div class="cart-item-image">
            <img src="${item.image}" alt="${item.title}">
          </div>
          <div class="cart-item-details">
            <h3 class="cart-item-name">${item.product_title}</h3>
            ${item.variant_title ? `<p class="cart-item-meta">${item.variant_title}</p>` : ''}
            <p class="cart-item-price">${formatCartMoney(item.final_line_price)}</p>
          </div>
          <div class="cart-item-quantity">
            <button type="button" class="qty-btn" onclick="changeCartItemQuantity('${item.key}', ${item.quantity - 1})">—</button>
            <span class="qty-number">${item.quantity}</span>
            <button type="button" class="qty-btn" onclick="changeCartItemQuantity('${item.key}', ${item.quantity + 1})">+</button>
          </div>
        </div>
      `;
      container.insertAdjacentHTML('beforeend', itemHTML);
    });

    if (subtotalElement) {
      subtotalElement.textContent = formatCartMoney(cart.total_price);
    }
  }

  function formatCartMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  window.changeCartItemQuantity = function(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(response => response.json())
    .then(cart => {
      renderCartDrawer(cart);
    })
    .catch(error => {
      console.error('Error al cambiar cantidad:', error);
    });
  }
});
